export default {
    id: null,
    first_name: null,
    last_name: null,
    email: null,
    username: null,
    address: null,
    city: null,
    state: null,
    country: null,
    zip: null,
    date_of_birth: null,
};
